var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeating = function SvgHeating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.552 5.024A4.83 4.83 0 0 1 20.379.199a4.83 4.83 0 0 1 4.826 4.827l.01 22.184c0 .343.146.672.403.9a7.87 7.87 0 0 1 2.606 5.844c0 4.325-3.52 7.845-7.845 7.845-4.326 0-7.846-3.52-7.846-7.845a7.87 7.87 0 0 1 2.608-5.844 1.2 1.2 0 0 0 .402-.9zm8.053.002A3.23 3.23 0 0 0 20.38 1.8a3.23 3.23 0 0 0-3.227 3.225l-.009 22.186c0 .798-.34 1.558-.933 2.09l-.17.158a6.27 6.27 0 0 0-1.907 4.496A6.255 6.255 0 0 0 20.38 40.2a6.255 6.255 0 0 0 6.245-6.245 6.27 6.27 0 0 0-2.073-4.651l-.124-.117a2.8 2.8 0 0 1-.813-1.976z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.378 11.777a.4.4 0 0 1 .394.328l.006.072v13.956l.017 3.32.015.002a4.25 4.25 0 0 1 2.946 1.81l.112.17a4.26 4.26 0 0 1-7.244 4.483.4.4 0 1 1 .68-.42 3.459 3.459 0 1 0 3.077-5.278.4.4 0 0 1-.378-.328l-.006-.07-.019-3.687V12.177c0-.22.18-.4.4-.4"
  })));
};
export default SvgHeating;